<template>
  <section v-if="offers && offers.length">
    <h2>{{ heading.title }}</h2>
    <div class="sub-heading">
      {{ heading.subtitle }}
    </div>
    <div class="offers">
      <a
        v-for="offer in offers"
        :key="offer.id"
        :href="offer.url"
      >
        <img
          :src="offer.image.high"
        >
        <offers-countdown
          v-if="now"
          :end="offer.end_at"
          @expired="updateOffers"
        />
      </a>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import OffersCountdown from './OffersCountdown'

export default {
  name: 'HomeOffers',
  components: {
    OffersCountdown,
  },
  watch: {
    api: {
      handler: 'onApiReady',
      immediate: true,
    },

  },
  computed: {
    ...mapState(['api']),
    ...mapState('offers', ['now', 'offers', 'heading']),
  },
  methods: {
    async onApiReady() {
      this.$store.dispatch('offers/INIT_OFFERS')
    },
    updateOffers() {
      this.$store.dispatch('offers/GET_OFFERS')
    },
  },
}
</script>
<style lang="scss" scoped>

section {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 80px auto auto;
  padding: 0 10px 50px;
  width: 100%;

  @include teq-breakpoint($wide) {
    max-width: calc(100% - 186px);
    padding: 0 0 50px;
  }
}

h2 {
  font-size: 3rem;
}

.sub-heading {
  color: black;
  font-size: 3rem;
  margin: 0 0 25px;
}

.offers {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 -10px;

  @include teq-breakpoint($large) {
    flex-direction: row;
  }
}

a {
  display: block;
  margin: 10px 0 0;
  max-width: calc(100vw - 10px);

  @include teq-breakpoint($large) {
    flex: 1;
    margin: 0 10px;
  }
}

img {
  display: block;
  margin: auto;
  max-width: 100%;
}
</style>
